import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "other" }

import { useUserStore } from "@/stores/user";
import { ElButton } from 'element-plus'
import { clickmakeCustomized } from '@/common/design'
import { computed } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'other',
  setup(__props) {

const userStore = useUserStore();
const islogin = userStore.isLoggedIn
const urlParams = new URLSearchParams(window.location.search)
const query = Object.fromEntries(urlParams.entries())

const isCustomized = computed(() => {
    return query.order_no && islogin
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isCustomized.value)
      ? (_openBlock(), _createBlock(_unref(ElButton), {
          key: 0,
          type: "primary",
          onClick: _unref(clickmakeCustomized)
        }, {
          default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
            _createTextVNode("生成定制图", -1)
          ]))]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}
}

})